import fb from "./fb.png"

const FbIcon = () => {
  return (
    <img
      src={fb}
      width="41"
      height="40"
      viewBox="0 0 67 66"
      fill="none"
      
    >
      
    </img>
  )
}

export default FbIcon
